import React from 'preact/compat'
import TwoFAEnableForm from './TwoFAEnableForm'
import TwoFADisableForm from './TwoFADisableForm'
import Modal from '../Modal'

export default ({
  type,
  onClose
}: {
  type: 'enable'|'disable',
  onClose: () => void
}) => {
  if (type === 'enable') {
    return <Modal showClose onClose={onClose}>
      <TwoFAEnableForm close={onClose} />
    </Modal>
  } else {
    return <Modal showClose onClose={onClose}>
      <TwoFADisableForm close={onClose} />
    </Modal>
  }
}
